module.exports = __webpack_public_path__ + "media/images/lp_right-6a09b9954e200e41af66dbc1d17142c7.webp";